// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
}
.contact-detail__constrained {
  max-width: 720px;
  margin: 0 auto;
  width: 100%;
  padding: 48px 48px 80px;
}
.contact-detail__header {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 28px;
}
.contact-detail__avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  background: var(--theme-bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
}
.contact-detail__avatar[data-color="0"] {
  background: #dbeafe;
}
.contact-detail__avatar[data-color="1"] {
  background: #d1fae5;
}
.contact-detail__avatar[data-color="2"] {
  background: #ede9fe;
}
.contact-detail__avatar[data-color="3"] {
  background: #fce7f3;
}
.contact-detail__avatar[data-color="4"] {
  background: #ffedd5;
}
.contact-detail__avatar[data-color="5"] {
  background: #e0f2fe;
}
.contact-detail__avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.contact-detail__avatar-initials {
  font-size: 22px;
  font-weight: var(--font-weight-semibold);
  color: var(--theme-text-secondary);
}
.contact-detail__avatar[data-color="0"] .contact-detail__avatar-initials {
  color: #1d4ed8;
}
.contact-detail__avatar[data-color="1"] .contact-detail__avatar-initials {
  color: #065f46;
}
.contact-detail__avatar[data-color="2"] .contact-detail__avatar-initials {
  color: #5b21b6;
}
.contact-detail__avatar[data-color="3"] .contact-detail__avatar-initials {
  color: #9d174d;
}
.contact-detail__avatar[data-color="4"] .contact-detail__avatar-initials {
  color: #9a3412;
}
.contact-detail__avatar[data-color="5"] .contact-detail__avatar-initials {
  color: #075985;
}
.contact-detail__header-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 2px;
}
.contact-detail__name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.contact-detail__name {
  margin: 0;
  font-size: 28px;
  font-weight: var(--font-weight-bold);
  color: var(--theme-text-primary);
  line-height: 1.1;
}
.contact-detail__role {
  margin: 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--theme-text-secondary);
}
.contact-detail__header-badges {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 2px;
}
.contact-detail__warmth {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-secondary);
}
.contact-detail__warmth--hot {
  background: #fee2e2;
  color: #dc2626;
}
.contact-detail__warmth--warm {
  background: #fef3c7;
  color: #d97706;
}
.contact-detail__warmth--cool {
  background: #dbeafe;
  color: #2563eb;
}
.contact-detail__warmth--cold {
  background: var(--theme-bg-muted);
  color: var(--theme-text-muted);
}
.contact-detail__primary-channel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  padding: 3px 8px 3px 3px;
  border-radius: 20px;
  background: var(--theme-bg-secondary);
  border: 1px solid var(--theme-border-soft);
  width: -webkit-fit-content;
  width: fit-content;
}
.contact-detail__primary-channel-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.contact-detail__primary-channel-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--theme-text-secondary);
}
.contact-detail__identity-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 8px;
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-muted);
  vertical-align: middle;
}
.contact-detail__identity-badge--ai {
  background: #ede9fe;
  color: #7c3aed;
}
.contact-detail__identity-badge--account {
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-secondary);
}
.contact-detail__tier-badge {
  display: inline-flex;
  align-items: center;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  padding: 3px 9px;
  border-radius: var(--radius-xs);
  width: -webkit-fit-content;
  width: fit-content;
  margin-top: 2px;
}
.contact-detail__tier-badge--close {
  background: var(--theme-primary-soft);
  color: var(--theme-primary-text);
}
.contact-detail__tier-badge--regular {
  background: #ecfdf5;
  background: var(--theme-success-bg, #ecfdf5);
  color: var(--theme-success);
}
.contact-detail__tier-badge--archived {
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-muted);
}
.contact-detail__tier-desc {
  font-weight: var(--font-weight-normal);
  opacity: 0.8;
}
.contact-detail__header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding-top: 6px;
}
.contact-detail__delete-confirm-label {
  font-size: var(--font-size-sm);
  color: var(--theme-danger);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
}
.contact-detail__icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: var(--radius-md);
  border: 1px solid var(--theme-border-primary);
  background: var(--theme-bg-primary);
  color: var(--theme-text-secondary);
  cursor: pointer;
  transition: all 0.12s;
}
.contact-detail__icon-btn:hover {
  background: var(--theme-hover-neutral);
  color: var(--theme-text-primary);
}
.contact-detail__icon-btn--danger:hover {
  color: var(--theme-danger);
  border-color: var(--theme-danger);
  background: #fef2f2;
  background: var(--theme-danger-bg, #fef2f2);
}
.contact-detail__icon-btn--danger-solid {
  background: var(--theme-danger);
  color: #fff;
  border-color: var(--theme-danger);
}
.contact-detail__icon-btn--danger-solid:hover {
  background: var(--theme-danger);
  opacity: 0.9;
}
.contact-detail__stale-alert {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: #fffbeb;
  background: var(--theme-warning-bg, #fffbeb);
  color: var(--theme-warning);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  margin-bottom: 28px;
}
.contact-detail__section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid var(--theme-border-soft);
}
.contact-detail__section--first {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}
.contact-detail__section-title {
  margin: 0;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--theme-text-muted);
}
.contact-detail__section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.contact-detail__add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--theme-border-primary);
  background: var(--theme-bg-primary);
  color: var(--theme-text-secondary);
  cursor: pointer;
  transition: all 0.12s;
  flex-shrink: 0;
}
.contact-detail__add-btn:hover {
  background: var(--theme-bg-hover);
  color: var(--theme-primary);
  border-color: var(--theme-primary);
}
.contact-detail__timeline {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.contact-detail__timeline-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 10px;
  border-radius: var(--radius-sm);
  background: var(--theme-bg-secondary);
  border: 1px solid var(--theme-border-soft);
  transition: background 0.1s;
}
.contact-detail__timeline-item:hover {
  background: var(--theme-bg-hover);
}
.contact-detail__timeline-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}
.contact-detail__timeline-icon svg {
  color: #fff;
}
.contact-detail__timeline-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.contact-detail__timeline-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.contact-detail__timeline-when {
  font-size: 12px;
  font-weight: 600;
  color: var(--theme-text-primary);
}
.contact-detail__timeline-channel {
  font-size: 11px;
  color: var(--theme-text-muted);
  background: var(--theme-bg-tertiary);
  padding: 1px 6px;
  border-radius: 8px;
}
.contact-detail__timeline-dir {
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border-radius: 6px;
}
.contact-detail__timeline-dir--outbound {
  background: var(--theme-primary-soft);
  color: var(--theme-primary);
}
.contact-detail__timeline-dir--inbound {
  background: var(--theme-success-bg);
  color: var(--theme-success);
}
.contact-detail__timeline-dir--both {
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-muted);
}
.contact-detail__timeline-snippet {
  margin: 0;
  font-size: 12px;
  color: var(--theme-text-secondary);
  font-style: italic;
  line-height: 1.5;
}
.contact-detail__timeline-delete {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: var(--theme-text-muted);
  cursor: pointer;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.1s;
}
.contact-detail__timeline-item:hover .contact-detail__timeline-delete {
  opacity: 1;
}
.contact-detail__timeline-delete:hover {
  background: var(--theme-danger-bg);
  color: var(--theme-danger);
}
.contact-detail__timeline-more {
  font-size: 12px;
  color: var(--theme-primary);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 0;
  text-align: left;
}
.contact-detail__timeline-more:hover {
  text-decoration: underline;
}
.contact-detail__timeline-empty {
  font-size: 13px;
  color: var(--theme-text-muted);
  font-style: italic;
  margin: 0;
  padding: 4px 0;
}
.contact-detail__log-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: var(--theme-bg-secondary);
  border: 1px solid var(--theme-border-soft);
  border-radius: var(--radius-sm);
}
.contact-detail__log-form-row {
  display: flex;
  gap: 8px;
}
.contact-detail__log-select {
  flex: 1 1;
  padding: 5px 8px;
  border: 1px solid var(--theme-border-primary);
  border-radius: var(--radius-sm);
  background: var(--theme-bg-primary);
  color: var(--theme-text-primary);
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
}
.contact-detail__log-select:focus {
  outline: none;
  border-color: var(--theme-primary);
}
.contact-detail__log-textarea {
  padding: 6px 10px;
  border: 1px solid var(--theme-border-primary);
  border-radius: var(--radius-sm);
  background: var(--theme-bg-primary);
  color: var(--theme-text-primary);
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  line-height: 1.5;
}
.contact-detail__log-textarea:focus {
  outline: none;
  border-color: var(--theme-primary);
}
.contact-detail__log-form-actions {
  display: flex;
  gap: 8px;
}
.contact-detail__log-btn {
  padding: 5px 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--theme-border-primary);
  background: var(--theme-bg-primary);
  color: var(--theme-text-secondary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.1s;
}
.contact-detail__log-btn:hover {
  background: var(--theme-bg-hover);
  color: var(--theme-text-primary);
}
.contact-detail__log-btn--primary {
  background: var(--theme-primary);
  border-color: var(--theme-primary);
  color: #fff;
}
.contact-detail__log-btn--primary:hover {
  opacity: 0.9;
}
.contact-detail__related {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.contact-detail__related-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--theme-border-soft);
  background: var(--theme-bg-secondary);
  cursor: pointer;
  text-align: left;
  transition: background 0.1s;
  font-family: inherit;
}
.contact-detail__related-item:hover {
  background: var(--theme-bg-hover);
}
.contact-detail__related-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--theme-bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  font-size: 11px;
  font-weight: 600;
  color: var(--theme-text-secondary);
}
.contact-detail__related-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.contact-detail__related-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.contact-detail__related-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--theme-text-primary);
}
.contact-detail__related-type {
  font-size: 11px;
  color: var(--theme-text-muted);
}
.contact-detail__interaction {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.contact-detail__interaction-when {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--theme-text-primary);
}
.contact-detail__interaction-snippet {
  margin: 0;
  font-size: var(--font-size-md);
  color: var(--theme-text-secondary);
  font-style: italic;
  line-height: 1.55;
}
.contact-detail__reachout {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: var(--font-size-base);
  color: var(--theme-primary);
}
.contact-detail__reachout-reason {
  color: var(--theme-text-secondary);
  font-size: var(--font-size-md);
}
.contact-detail__topics, .contact-detail__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.contact-detail__topic-chip {
  font-size: var(--font-size-sm);
  padding: 4px 10px;
  border-radius: var(--radius-xs);
  background: var(--theme-primary-soft);
  color: var(--theme-primary-text);
  font-weight: var(--font-weight-medium);
}
.contact-detail__tag-chip {
  font-size: var(--font-size-sm);
  padding: 4px 10px;
  border-radius: var(--radius-xs);
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-secondary);
  font-weight: var(--font-weight-medium);
}
.contact-detail__signals {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.contact-detail__signal {
  display: flex;
  gap: 10px;
  padding: 10px 14px;
  background: var(--theme-bg-secondary);
  border-radius: var(--radius-md);
  border: 1px solid var(--theme-border-soft);
  box-shadow: var(--theme-shadow-subtle);
}
.contact-detail__signal-icon {
  color: var(--theme-text-muted);
  flex-shrink: 0;
  margin-top: 2px;
}
.contact-detail__signal-content {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.contact-detail__signal-title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--theme-text-primary);
}
.contact-detail__signal-body {
  margin: 0;
  font-size: var(--font-size-md);
  color: var(--theme-text-secondary);
  line-height: 1.5;
}
.contact-detail__signal-date {
  font-size: var(--font-size-xs);
  color: var(--theme-text-muted);
  margin-top: 1px;
}
.contact-detail__info-rows {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.contact-detail__info-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  margin: 0 -8px;
  width: calc(100% + 16px);
  box-sizing: border-box;
  border-radius: var(--radius-md);
  border: none;
  background: transparent;
  font-size: var(--font-size-base);
  font-family: inherit;
  color: var(--theme-text-primary);
  text-decoration: none;
  text-align: left;
  justify-content: flex-start;
  cursor: pointer;
  transition: background 0.1s;
}
.contact-detail__info-row:hover {
  background: var(--theme-hover-neutral);
}
.contact-detail__info-row--empty {
  color: var(--theme-text-muted);
  font-style: italic;
}
.contact-detail__info-row--empty svg {
  opacity: 0.4;
}
.contact-detail__info-row--empty:hover {
  color: var(--theme-text-secondary);
}
.contact-detail__info-row--empty:hover svg {
  opacity: 0.7;
}
.contact-detail__preferred-badge {
  font-size: var(--font-size-xs);
  padding: 2px 6px;
  border-radius: var(--radius-xs);
  background: #ecfdf5;
  background: var(--theme-success-bg, #ecfdf5);
  color: var(--theme-success);
  font-weight: var(--font-weight-semibold);
  margin-left: auto;
}
.contact-detail__notes {
  margin: 0;
  font-size: var(--font-size-base);
  color: var(--theme-text-secondary);
  line-height: 1.65;
  white-space: pre-wrap;
}
.contact-detail__sources {
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid var(--theme-border-soft);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.contact-detail__sources-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.contact-detail__source-badge {
  display: flex;
  align-items: center;
  gap: 6px;
}
.contact-detail__source-icon {
  width: 22px;
  height: 22px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.contact-detail__source-label {
  font-size: var(--font-size-sm);
  color: var(--theme-text-secondary);
  font-weight: var(--font-weight-medium);
}
.contact-detail__sources-enriched {
  font-size: var(--font-size-xs);
  color: var(--theme-text-muted);
}
.contact-detail__back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 12px 0 0 12px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--theme-border-primary);
  background: var(--theme-bg-primary);
  color: var(--theme-text-secondary);
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.12s;
}
.contact-detail__back-btn:hover {
  background: var(--theme-bg-hover);
  color: var(--theme-text-primary);
}
@media (max-width: 768px) {
  .contact-detail__constrained {
    padding: 20px 16px 60px;
  }
  .contact-detail__header {
    gap: 12px;
    margin-bottom: 20px;
  }
  .contact-detail__avatar {
    width: 48px;
    height: 48px;
  }
  .contact-detail__avatar-initials {
    font-size: 17px;
  }
  .contact-detail__name {
    font-size: 22px;
  }
  .contact-detail__tier-desc {
    display: none;
  }
  .contact-detail__timeline-delete {
    opacity: 1;
  }
  .contact-detail__header-actions {
    flex-wrap: wrap;
    gap: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/apps/ContactsApp/components/ContactDetail/ContactDetail.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;AACJ;AAIE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAFJ;AAKE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAMI;EAAoB,mBAAA;AAHxB;AAII;EAAoB,mBAAA;AADxB;AAEI;EAAoB,mBAAA;AACxB;AAAI;EAAoB,mBAAA;AAGxB;AAFI;EAAoB,mBAAA;AAKxB;AAJI;EAAoB,mBAAA;AAOxB;AAJE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAMJ;AAHE;EACE,eAAA;EACA,wCAAA;EACA,kCAAA;AAKJ;AAHI;EAA4C,cAAA;AAMhD;AALI;EAA4C,cAAA;AAQhD;AAPI;EAA4C,cAAA;AAUhD;AATI;EAA4C,cAAA;AAYhD;AAXI;EAA4C,cAAA;AAchD;AAbI;EAA4C,cAAA;AAgBhD;AAbE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAeJ;AAZE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAcJ;AAXE;EACE,SAAA;EACA,eAAA;EACA,oCAAA;EACA,gCAAA;EACA,gBAAA;AAaJ;AAVE;EACE,SAAA;EACA,gCAAA;EACA,sCAAA;EACA,kCAAA;AAYJ;AATE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AAWJ;AARE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kCAAA;AAUJ;AARI;EAAU,mBAAA;EAAqB,cAAA;AAYnC;AAXI;EAAU,mBAAA;EAAqB,cAAA;AAenC;AAdI;EAAU,mBAAA;EAAqB,cAAA;AAkBnC;AAjBI;EAAU,iCAAA;EAAmC,8BAAA;AAqBjD;AAlBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,qCAAA;EACA,0CAAA;EACA,0BAAA;EAAA,kBAAA;AAoBJ;AAjBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAmBJ;AAhBE;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;AAkBJ;AAfE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,8BAAA;EACA,sBAAA;AAiBJ;AAfI;EAAa,mBAAA;EAAqB,cAAA;AAmBtC;AAlBI;EAAa,oCAAA;EAAsC,kCAAA;AAsBvD;AAnBE;EACE,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gBAAA;EACA,+BAAA;EACA,0BAAA;EAAA,kBAAA;EACA,eAAA;AAqBJ;AAnBI;EAAc,qCAAA;EAAuC,gCAAA;AAuBzD;AAtBI;EAAc,mBAAA;EAAA,4CAAA;EAA8C,2BAAA;AA0BhE;AAzBI;EAAc,oCAAA;EAAsC,8BAAA;AA6BxD;AA1BE;EACE,sCAAA;EACA,YAAA;AA4BJ;AAzBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;AA2BJ;AAxBE;EACE,8BAAA;EACA,0BAAA;EACA,sCAAA;EACA,mBAAA;AA0BJ;AAvBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,6CAAA;EACA,mCAAA;EACA,kCAAA;EACA,eAAA;EACA,qBAAA;AAyBJ;AAvBI;EACE,sCAAA;EACA,gCAAA;AAyBN;AAtBI;EACE,0BAAA;EACA,iCAAA;EACA,mBAAA;EAAA,2CAAA;AAwBN;AArBI;EACE,+BAAA;EACA,WAAA;EACA,iCAAA;AAuBN;AArBM;EAAU,+BAAA;EAAiC,YAAA;AAyBjD;AAnBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EAAA,4CAAA;EACA,2BAAA;EACA,+BAAA;EACA,8BAAA;EACA,sCAAA;EACA,mBAAA;AAqBJ;AAlBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,8CAAA;AAoBJ;AAlBI;EACE,aAAA;EACA,cAAA;EACA,gBAAA;AAoBN;AAhBE;EACE,SAAA;EACA,8BAAA;EACA,wCAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;AAkBJ;AAfE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAiBJ;AAdE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,6CAAA;EACA,mCAAA;EACA,kCAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AAgBJ;AAdI;EACE,iCAAA;EACA,2BAAA;EACA,kCAAA;AAgBN;AAVE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAYJ;AATE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,+BAAA;EACA,qCAAA;EACA,0CAAA;EACA,2BAAA;AAWJ;AATI;EAAU,iCAAA;AAYd;AATE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAWJ;AATI;EAAM,WAAA;AAYV;AATE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAWJ;AARE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAUJ;AAPE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;AASJ;AANE;EACE,eAAA;EACA,8BAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;AAQJ;AALE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAOJ;AALI;EAAc,qCAAA;EAAuC,2BAAA;AASzD;AARI;EAAc,mCAAA;EAAqC,2BAAA;AAYvD;AAXI;EAAc,oCAAA;EAAsC,8BAAA;AAexD;AAZE;EACE,SAAA;EACA,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;AAcJ;AAXE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,wBAAA;AAaJ;AAXI;EAAyC,UAAA;AAc7C;AAbI;EAAU,kCAAA;EAAoC,0BAAA;AAiBlD;AAdE;EACE,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAgBJ;AAdI;EAAU,0BAAA;AAiBd;AAdE;EACE,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AAgBJ;AAXE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,qCAAA;EACA,0CAAA;EACA,+BAAA;AAaJ;AAVE;EACE,aAAA;EACA,QAAA;AAYJ;AATE;EACE,SAAA;EACA,gBAAA;EACA,6CAAA;EACA,+BAAA;EACA,mCAAA;EACA,gCAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;AAWJ;AATI;EAAU,aAAA;EAAe,kCAAA;AAa7B;AAVE;EACE,iBAAA;EACA,6CAAA;EACA,+BAAA;EACA,mCAAA;EACA,gCAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;AAYJ;AAVI;EAAU,aAAA;EAAe,kCAAA;AAc7B;AAXE;EACE,aAAA;EACA,QAAA;AAaJ;AAVE;EACE,iBAAA;EACA,+BAAA;EACA,6CAAA;EACA,mCAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,oBAAA;AAYJ;AAVI;EAAU,iCAAA;EAAmC,gCAAA;AAcjD;AAZI;EACE,gCAAA;EACA,kCAAA;EACA,WAAA;AAcN;AAZM;EAAU,YAAA;AAehB;AATE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAWJ;AARE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,+BAAA;EACA,0CAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,oBAAA;AAUJ;AARI;EAAU,iCAAA;AAWd;AARE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;AAUJ;AARI;EAAM,WAAA;EAAa,YAAA;EAAc,iBAAA;AAarC;AAVE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAYJ;AATE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;AAWJ;AARE;EACE,eAAA;EACA,8BAAA;AAUJ;AALE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAOJ;AAJE;EACE,gCAAA;EACA,sCAAA;EACA,gCAAA;AAMJ;AAHE;EACE,SAAA;EACA,8BAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;AAKJ;AAFE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,gCAAA;EACA,2BAAA;AAIJ;AADE;EACE,kCAAA;EACA,8BAAA;AAGJ;AAAE;EAEE,aAAA;EACA,eAAA;EACA,QAAA;AACJ;AAEE;EACE,8BAAA;EACA,iBAAA;EACA,+BAAA;EACA,qCAAA;EACA,gCAAA;EACA,sCAAA;AAAJ;AAGE;EACE,8BAAA;EACA,iBAAA;EACA,+BAAA;EACA,oCAAA;EACA,kCAAA;EACA,sCAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAFJ;AAKE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;EACA,0CAAA;EACA,sCAAA;AAHJ;AAME;EACE,8BAAA;EACA,cAAA;EACA,eAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AALJ;AAQE;EACE,8BAAA;EACA,sCAAA;EACA,gCAAA;AANJ;AASE;EACE,SAAA;EACA,8BAAA;EACA,kCAAA;EACA,gBAAA;AAPJ;AAUE;EACE,8BAAA;EACA,8BAAA;EACA,eAAA;AARJ;AAWE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,wBAAA;EACA,sBAAA;EACA,+BAAA;EACA,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,oBAAA;EACA,gCAAA;EACA,qBAAA;EACA,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;AAVJ;AAYI;EAAU,sCAAA;AATd;AAWI;EACE,8BAAA;EACA,kBAAA;AATN;AAWM;EAAM,YAAA;AARZ;AAUM;EACE,kCAAA;AARR;AASQ;EAAM,YAAA;AANd;AAWE;EACE,8BAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EAAA,4CAAA;EACA,2BAAA;EACA,wCAAA;EACA,iBAAA;AATJ;AAYE;EACE,SAAA;EACA,gCAAA;EACA,kCAAA;EACA,iBAAA;EACA,qBAAA;AAVJ;AAeE;EACE,gBAAA;EACA,iBAAA;EACA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAbJ;AAgBE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAdJ;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAfJ;AAkBE;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,wCAAA;AAhBJ;AAmBE;EACE,8BAAA;EACA,kCAAA;EACA,sCAAA;AAjBJ;AAoBE;EACE,8BAAA;EACA,8BAAA;AAlBJ;AAsBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,+BAAA;EACA,6CAAA;EACA,mCAAA;EACA,kCAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AApBJ;AAsBI;EACE,iCAAA;EACA,gCAAA;AApBN;AAwBE;EACE;IACE,uBAAA;EAtBJ;EAyBE;IACE,SAAA;IACA,mBAAA;EAvBJ;EA0BE;IACE,WAAA;IACA,YAAA;EAxBJ;EA2BE;IACE,eAAA;EAzBJ;EA4BE;IACE,eAAA;EA1BJ;EA6BE;IACE,aAAA;EA3BJ;EA8BE;IACE,UAAA;EA5BJ;EA+BE;IACE,eAAA;IACA,QAAA;EA7BJ;AACF","sourcesContent":[".contact-detail {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n\n  &__constrained {\n    max-width: 720px;\n    margin: 0 auto;\n    width: 100%;\n    padding: 48px 48px 80px;\n  }\n\n  // ── Header ────────────────────────────────────────────────────────────────\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    gap: 20px;\n    margin-bottom: 28px;\n  }\n\n  &__avatar {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    overflow: hidden;\n    background: var(--theme-bg-tertiary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    // Color slots — same palette as ContactList\n    &[data-color=\"0\"] { background: #dbeafe; }\n    &[data-color=\"1\"] { background: #d1fae5; }\n    &[data-color=\"2\"] { background: #ede9fe; }\n    &[data-color=\"3\"] { background: #fce7f3; }\n    &[data-color=\"4\"] { background: #ffedd5; }\n    &[data-color=\"5\"] { background: #e0f2fe; }\n  }\n\n  &__avatar-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__avatar-initials {\n    font-size: 22px;\n    font-weight: var(--font-weight-semibold);\n    color: var(--theme-text-secondary);\n\n    .contact-detail__avatar[data-color=\"0\"] & { color: #1d4ed8; }\n    .contact-detail__avatar[data-color=\"1\"] & { color: #065f46; }\n    .contact-detail__avatar[data-color=\"2\"] & { color: #5b21b6; }\n    .contact-detail__avatar[data-color=\"3\"] & { color: #9d174d; }\n    .contact-detail__avatar[data-color=\"4\"] & { color: #9a3412; }\n    .contact-detail__avatar[data-color=\"5\"] & { color: #075985; }\n  }\n\n  &__header-info {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding-top: 2px;\n  }\n\n  &__name-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  &__name {\n    margin: 0;\n    font-size: 28px;\n    font-weight: var(--font-weight-bold);\n    color: var(--theme-text-primary);\n    line-height: 1.1;\n  }\n\n  &__role {\n    margin: 0;\n    font-size: var(--font-size-base);\n    font-weight: var(--font-weight-medium);\n    color: var(--theme-text-secondary);\n  }\n\n  &__header-badges {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n    margin-top: 2px;\n  }\n\n  &__warmth {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 10px;\n    background: var(--theme-bg-tertiary);\n    color: var(--theme-text-secondary);\n\n    &--hot  { background: #fee2e2; color: #dc2626; }\n    &--warm { background: #fef3c7; color: #d97706; }\n    &--cool { background: #dbeafe; color: #2563eb; }\n    &--cold { background: var(--theme-bg-muted); color: var(--theme-text-muted); }\n  }\n\n  &__primary-channel {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 4px;\n    padding: 3px 8px 3px 3px;\n    border-radius: 20px;\n    background: var(--theme-bg-secondary);\n    border: 1px solid var(--theme-border-soft);\n    width: fit-content;\n  }\n\n  &__primary-channel-icon {\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n\n  &__primary-channel-label {\n    font-size: 11px;\n    font-weight: 500;\n    color: var(--theme-text-secondary);\n  }\n\n  &__identity-badge {\n    font-size: 10px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border-radius: 8px;\n    background: var(--theme-bg-tertiary);\n    color: var(--theme-text-muted);\n    vertical-align: middle;\n\n    &--ai      { background: #ede9fe; color: #7c3aed; }\n    &--account { background: var(--theme-bg-tertiary); color: var(--theme-text-secondary); }\n  }\n\n  &__tier-badge {\n    display: inline-flex;\n    align-items: center;\n    font-size: var(--font-size-xs);\n    font-weight: var(--font-weight-semibold);\n    padding: 3px 9px;\n    border-radius: var(--radius-xs);\n    width: fit-content;\n    margin-top: 2px;\n\n    &--close    { background: var(--theme-primary-soft); color: var(--theme-primary-text); }\n    &--regular  { background: var(--theme-success-bg, #ecfdf5); color: var(--theme-success); }\n    &--archived { background: var(--theme-bg-tertiary); color: var(--theme-text-muted); }\n  }\n\n  &__tier-desc {\n    font-weight: var(--font-weight-normal);\n    opacity: 0.8;\n  }\n\n  &__header-actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n    padding-top: 6px;\n  }\n\n  &__delete-confirm-label {\n    font-size: var(--font-size-sm);\n    color: var(--theme-danger);\n    font-weight: var(--font-weight-medium);\n    white-space: nowrap;\n  }\n\n  &__icon-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--theme-border-primary);\n    background: var(--theme-bg-primary);\n    color: var(--theme-text-secondary);\n    cursor: pointer;\n    transition: all 0.12s;\n\n    &:hover {\n      background: var(--theme-hover-neutral);\n      color: var(--theme-text-primary);\n    }\n\n    &--danger:hover {\n      color: var(--theme-danger);\n      border-color: var(--theme-danger);\n      background: var(--theme-danger-bg, #fef2f2);\n    }\n\n    &--danger-solid {\n      background: var(--theme-danger);\n      color: #fff;\n      border-color: var(--theme-danger);\n\n      &:hover { background: var(--theme-danger); opacity: 0.9; }\n    }\n  }\n\n  // ── Body sections ─────────────────────────────────────────────────────────\n\n  &__stale-alert {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px 14px;\n    background: var(--theme-warning-bg, #fffbeb);\n    color: var(--theme-warning);\n    border-radius: var(--radius-md);\n    font-size: var(--font-size-sm);\n    font-weight: var(--font-weight-medium);\n    margin-bottom: 28px;\n  }\n\n  &__section {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 28px;\n    padding-top: 20px;\n    border-top: 1px solid var(--theme-border-soft);\n\n    &--first {\n      margin-top: 0;\n      padding-top: 0;\n      border-top: none;\n    }\n  }\n\n  &__section-title {\n    margin: 0;\n    font-size: var(--font-size-xs);\n    font-weight: var(--font-weight-semibold);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: var(--theme-text-muted);\n  }\n\n  &__section-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  &__add-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--theme-border-primary);\n    background: var(--theme-bg-primary);\n    color: var(--theme-text-secondary);\n    cursor: pointer;\n    transition: all 0.12s;\n    flex-shrink: 0;\n\n    &:hover {\n      background: var(--theme-bg-hover);\n      color: var(--theme-primary);\n      border-color: var(--theme-primary);\n    }\n  }\n\n  // ── Interaction timeline ───────────────────────────────────────────────────\n\n  &__timeline {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__timeline-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 8px 10px;\n    border-radius: var(--radius-sm);\n    background: var(--theme-bg-secondary);\n    border: 1px solid var(--theme-border-soft);\n    transition: background 0.1s;\n\n    &:hover { background: var(--theme-bg-hover); }\n  }\n\n  &__timeline-icon {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    margin-top: 1px;\n\n    svg { color: #fff; }\n  }\n\n  &__timeline-body {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__timeline-meta {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n\n  &__timeline-when {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--theme-text-primary);\n  }\n\n  &__timeline-channel {\n    font-size: 11px;\n    color: var(--theme-text-muted);\n    background: var(--theme-bg-tertiary);\n    padding: 1px 6px;\n    border-radius: 8px;\n  }\n\n  &__timeline-dir {\n    font-size: 10px;\n    font-weight: 600;\n    padding: 1px 5px;\n    border-radius: 6px;\n\n    &--outbound { background: var(--theme-primary-soft); color: var(--theme-primary); }\n    &--inbound  { background: var(--theme-success-bg); color: var(--theme-success); }\n    &--both     { background: var(--theme-bg-tertiary); color: var(--theme-text-muted); }\n  }\n\n  &__timeline-snippet {\n    margin: 0;\n    font-size: 12px;\n    color: var(--theme-text-secondary);\n    font-style: italic;\n    line-height: 1.5;\n  }\n\n  &__timeline-delete {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    border: none;\n    background: transparent;\n    color: var(--theme-text-muted);\n    cursor: pointer;\n    flex-shrink: 0;\n    opacity: 0;\n    transition: opacity 0.1s;\n\n    .contact-detail__timeline-item:hover & { opacity: 1; }\n    &:hover { background: var(--theme-danger-bg); color: var(--theme-danger); }\n  }\n\n  &__timeline-more {\n    font-size: 12px;\n    color: var(--theme-primary);\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px 0;\n    text-align: left;\n\n    &:hover { text-decoration: underline; }\n  }\n\n  &__timeline-empty {\n    font-size: 13px;\n    color: var(--theme-text-muted);\n    font-style: italic;\n    margin: 0;\n    padding: 4px 0;\n  }\n\n  // ── Log interaction form ───────────────────────────────────────────────────\n\n  &__log-form {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 12px;\n    background: var(--theme-bg-secondary);\n    border: 1px solid var(--theme-border-soft);\n    border-radius: var(--radius-sm);\n  }\n\n  &__log-form-row {\n    display: flex;\n    gap: 8px;\n  }\n\n  &__log-select {\n    flex: 1;\n    padding: 5px 8px;\n    border: 1px solid var(--theme-border-primary);\n    border-radius: var(--radius-sm);\n    background: var(--theme-bg-primary);\n    color: var(--theme-text-primary);\n    font-size: 12px;\n    font-family: inherit;\n    cursor: pointer;\n\n    &:focus { outline: none; border-color: var(--theme-primary); }\n  }\n\n  &__log-textarea {\n    padding: 6px 10px;\n    border: 1px solid var(--theme-border-primary);\n    border-radius: var(--radius-sm);\n    background: var(--theme-bg-primary);\n    color: var(--theme-text-primary);\n    font-size: 13px;\n    font-family: inherit;\n    resize: vertical;\n    line-height: 1.5;\n\n    &:focus { outline: none; border-color: var(--theme-primary); }\n  }\n\n  &__log-form-actions {\n    display: flex;\n    gap: 8px;\n  }\n\n  &__log-btn {\n    padding: 5px 14px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--theme-border-primary);\n    background: var(--theme-bg-primary);\n    color: var(--theme-text-secondary);\n    font-size: 12px;\n    font-weight: 500;\n    cursor: pointer;\n    font-family: inherit;\n    transition: all 0.1s;\n\n    &:hover { background: var(--theme-bg-hover); color: var(--theme-text-primary); }\n\n    &--primary {\n      background: var(--theme-primary);\n      border-color: var(--theme-primary);\n      color: #fff;\n\n      &:hover { opacity: 0.9; }\n    }\n  }\n\n  // ── Related contacts ───────────────────────────────────────────────────────\n\n  &__related {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__related-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--theme-border-soft);\n    background: var(--theme-bg-secondary);\n    cursor: pointer;\n    text-align: left;\n    transition: background 0.1s;\n    font-family: inherit;\n\n    &:hover { background: var(--theme-bg-hover); }\n  }\n\n  &__related-avatar {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: var(--theme-bg-tertiary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    overflow: hidden;\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--theme-text-secondary);\n\n    img { width: 100%; height: 100%; object-fit: cover; }\n  }\n\n  &__related-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__related-name {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--theme-text-primary);\n  }\n\n  &__related-type {\n    font-size: 11px;\n    color: var(--theme-text-muted);\n  }\n\n  // ── Section content ───────────────────────────────────────────────────────\n\n  &__interaction {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__interaction-when {\n    font-size: var(--font-size-base);\n    font-weight: var(--font-weight-medium);\n    color: var(--theme-text-primary);\n  }\n\n  &__interaction-snippet {\n    margin: 0;\n    font-size: var(--font-size-md);\n    color: var(--theme-text-secondary);\n    font-style: italic;\n    line-height: 1.55;\n  }\n\n  &__reachout {\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n    font-size: var(--font-size-base);\n    color: var(--theme-primary);\n  }\n\n  &__reachout-reason {\n    color: var(--theme-text-secondary);\n    font-size: var(--font-size-md);\n  }\n\n  &__topics,\n  &__tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  &__topic-chip {\n    font-size: var(--font-size-sm);\n    padding: 4px 10px;\n    border-radius: var(--radius-xs);\n    background: var(--theme-primary-soft);\n    color: var(--theme-primary-text);\n    font-weight: var(--font-weight-medium);\n  }\n\n  &__tag-chip {\n    font-size: var(--font-size-sm);\n    padding: 4px 10px;\n    border-radius: var(--radius-xs);\n    background: var(--theme-bg-tertiary);\n    color: var(--theme-text-secondary);\n    font-weight: var(--font-weight-medium);\n  }\n\n  &__signals {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__signal {\n    display: flex;\n    gap: 10px;\n    padding: 10px 14px;\n    background: var(--theme-bg-secondary);\n    border-radius: var(--radius-md);\n    border: 1px solid var(--theme-border-soft);\n    box-shadow: var(--theme-shadow-subtle);\n  }\n\n  &__signal-icon {\n    color: var(--theme-text-muted);\n    flex-shrink: 0;\n    margin-top: 2px;\n  }\n\n  &__signal-content {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    min-width: 0;\n  }\n\n  &__signal-title {\n    font-size: var(--font-size-md);\n    font-weight: var(--font-weight-medium);\n    color: var(--theme-text-primary);\n  }\n\n  &__signal-body {\n    margin: 0;\n    font-size: var(--font-size-md);\n    color: var(--theme-text-secondary);\n    line-height: 1.5;\n  }\n\n  &__signal-date {\n    font-size: var(--font-size-xs);\n    color: var(--theme-text-muted);\n    margin-top: 1px;\n  }\n\n  &__info-rows {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__info-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 6px 8px;\n    margin: 0 -8px;\n    width: calc(100% + 16px);\n    box-sizing: border-box;\n    border-radius: var(--radius-md);\n    border: none;\n    background: transparent;\n    font-size: var(--font-size-base);\n    font-family: inherit;\n    color: var(--theme-text-primary);\n    text-decoration: none;\n    text-align: left;\n    justify-content: flex-start;\n    cursor: pointer;\n    transition: background 0.1s;\n\n    &:hover { background: var(--theme-hover-neutral); }\n\n    &--empty {\n      color: var(--theme-text-muted);\n      font-style: italic;\n\n      svg { opacity: 0.4; }\n\n      &:hover {\n        color: var(--theme-text-secondary);\n        svg { opacity: 0.7; }\n      }\n    }\n  }\n\n  &__preferred-badge {\n    font-size: var(--font-size-xs);\n    padding: 2px 6px;\n    border-radius: var(--radius-xs);\n    background: var(--theme-success-bg, #ecfdf5);\n    color: var(--theme-success);\n    font-weight: var(--font-weight-semibold);\n    margin-left: auto;\n  }\n\n  &__notes {\n    margin: 0;\n    font-size: var(--font-size-base);\n    color: var(--theme-text-secondary);\n    line-height: 1.65;\n    white-space: pre-wrap;\n  }\n\n  // ── Sources footer ────────────────────────────────────────────────────────\n\n  &__sources {\n    margin-top: 32px;\n    padding-top: 20px;\n    border-top: 1px solid var(--theme-border-soft);\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  &__sources-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  &__source-badge {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  &__source-icon {\n    width: 22px;\n    height: 22px;\n    border-radius: var(--radius-sm);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  }\n\n  &__source-label {\n    font-size: var(--font-size-sm);\n    color: var(--theme-text-secondary);\n    font-weight: var(--font-weight-medium);\n  }\n\n  &__sources-enriched {\n    font-size: var(--font-size-xs);\n    color: var(--theme-text-muted);\n  }\n\n  // Back button — visible only when rendered (mobile mode via onBack prop)\n  &__back-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    margin: 12px 0 0 12px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--theme-border-primary);\n    background: var(--theme-bg-primary);\n    color: var(--theme-text-secondary);\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: all 0.12s;\n\n    &:hover {\n      background: var(--theme-bg-hover);\n      color: var(--theme-text-primary);\n    }\n  }\n\n  @media (max-width: 768px) {\n    &__constrained {\n      padding: 20px 16px 60px;\n    }\n\n    &__header {\n      gap: 12px;\n      margin-bottom: 20px;\n    }\n\n    &__avatar {\n      width: 48px;\n      height: 48px;\n    }\n\n    &__avatar-initials {\n      font-size: 17px;\n    }\n\n    &__name {\n      font-size: 22px;\n    }\n\n    &__tier-desc {\n      display: none;\n    }\n\n    &__timeline-delete {\n      opacity: 1;\n    }\n\n    &__header-actions {\n      flex-wrap: wrap;\n      gap: 6px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
